import React from 'react';
import './about.styles.scss';

const About = () => (
  <>
    <main id="about-page">
      <header>
        <h1>Made by Team of _ ?</h1>
        <p>
          A Blog on <i>"theonlinestore.com"</i>
        </p>
      </header>
      <article>
        <h2>Team / Devs</h2>
        <p>
          Hello there! I'm Mohit "Cherry" Saini, 18yo, India. Started learning
          React.js previous year (2019), couldn't catch the JSX and surrendered.
          Months later, tried Anuglar but the decorator were magical for me and
          hopped onto React.js. This time i understood very well and started
          building e-comm website with my friend he didn't knew React.js so i
          had to start alone and this is the result after 3-4 months (was lazy).
          <i>- During the 2020 Pandemic</i>
        </p>
      </article>
      <article>
        <h2>This's complete, what now</h2>
        <p>
          I'm obessed with React.js now. Can't wait to start another project for
          fun + learning, Reasonml is going to be my new home. If anyone wanna
          collaborate on a project or discuss something you can contact me on
          discord. And i also play games like CSGO, Apex Legends. You can add me
          on Steam.com too.
        </p>
      </article>
      <article>
        <h2>
          About <i>"theonlinestore.com"</i>
        </h2>
        <p>
          This site is completely written using React.js & Firebase. Apis used
          in making of this project are : createContext, hooks, renderCallback,
          ReactDev Tools & Firebase SDK And Softwares are : VSCode, ChromeDev
          Tools, PowerShell, LoremIspsum, PicsumPhotos &{' '}
          <strong>Stackoverflow</strong>. All purchase and transaction are
          dumy/placeholder, no library like stripe used.
          <i>- Honorable mentions Google.com</i>
        </p>
      </article>
      <article>
        <h2>Credits</h2>
        <p>
          Any photo, video or other media isn't owned by me. This website
          doesn't have any real payment just dumies. This project is totally for
          educational purposes. All rights goes to there owner.
        </p>
      </article>
      <header>
        <h1>Have a Nice Day !</h1>
      </header>
    </main>
  </>
);
export default About;
